(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbuxus-spring-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-spring-countdown')) {
    customElements.define('tb-spring-countdown', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        const raw = (this.dataset.deadline || '').trim();
        this.end = Date.parse(raw);
        const valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(raw) && Number.isFinite(this.end);
        if (!valid) {
          if (this.dataset.editor === 'true') this.querySelector('[data-timer-error]').hidden = false;
          else this.hidden = true;
          return;
        }
        this.hidden = false;
        this.querySelector('[data-timer-error]').hidden = true;
        this.tick();
        if (this.end > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { this.stop(); }
      stop() { if (this.interval) clearInterval(this.interval); this.interval = null; }
      tick() {
        const total = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        const units = this.querySelector('[data-timer-units]');
        if (total === 0) {
          units.hidden = true;
          this.querySelector('[data-timer-label]').textContent = this.dataset.expired || 'Offer ended';
          const deadline = this.querySelector('[data-deadline-label]');
          if (deadline) deadline.hidden = true;
          this.stop();
          return;
        }
        const values = {days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60};
        for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        units.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topbuxus-sticky-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-sticky-sale-bar')) {
    customElements.define('tb-sticky-sale-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.bar) return;
        this.bar = this.querySelector('[data-sale-bar]');
        if (!this.bar) return;
        this.spacer = this.querySelector('[data-sale-spacer]');
        this.headerOffsets = new Map();
        this.originalScrollPadding = document.documentElement.style.scrollPaddingTop;
        this.scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        this.end = Date.parse((this.dataset.end || '').trim());
        const valid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test((this.dataset.end || '').trim()) && Number.isFinite(this.end);
        // Moving only the visual bar outside theme wrappers avoids clipped/fixed positioning.
        document.body.appendChild(this.bar);
        this.resize = () => this.measure();
        window.addEventListener('resize', this.resize, {passive:true});
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.resize);
          this.observer.observe(this.bar);
        }
        if (!valid) {
          if (this.dataset.editor === 'true') {
            this.bar.hidden = false;
            this.status('Set a valid countdown deadline in this section’s settings.');
            this.measure();
          }
          return;
        }
        this.bar.hidden = false;
        this.tick();
        if (this.end > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
        this.measure();
        this.frame = requestAnimationFrame(() => this.measure());
      }
      status(text) {
        const node = this.bar.querySelector('[data-status]');
        node.textContent = text;
        node.hidden = false;
      }
      tick() {
        const total = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        const countdown = this.bar.querySelector('[data-countdown]');
        if (total === 0) {
          clearInterval(this.interval);
          this.interval = null;
          countdown.hidden = true;
          if (this.dataset.hideExpired === 'true' && this.dataset.editor !== 'true') this.bar.hidden = true;
          else {
            this.bar.querySelector('.tb-sticky-sale__message').hidden = true;
            const link = this.bar.querySelector('[data-sale-link]');
            if (link) link.hidden = true;
            this.status(this.dataset.expired || 'This offer has ended');
          }
          this.measure();
          return;
        }
        const values = {days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};
        for (const [key,value] of Object.entries(values)) this.bar.querySelector(`[data-time="${key}"]`).textContent = String(value).padStart(2,'0');
        countdown.hidden = false;
      }
      measure() {
        if (!this.bar || !this.spacer) return;
        const height = this.bar.hidden ? 0 : Math.ceil(this.bar.getBoundingClientRect().height);
        this.spacer.style.height = `${height}px`;
        document.documentElement.style.scrollPaddingTop = `${this.scrollPadding + height}px`;
        if (!height) {this.restoreHeaders();return;}
        let headers = [];
        try {if (this.dataset.headerSelector.trim()) headers = document.querySelectorAll(this.dataset.headerSelector);} catch (_) {}
        // Offset only the actual sticky/fixed wrapper, not every nested header element.
        for (const header of headers) {
          const computed = getComputedStyle(header);
          if (!['sticky','fixed'].includes(computed.position)) continue;
          if (!this.headerOffsets.has(header)) this.headerOffsets.set(header,{top:header.style.getPropertyValue('top'),priority:header.style.getPropertyPriority('top'),base:parseFloat(computed.top)||0});
          const original = this.headerOffsets.get(header);
          header.style.setProperty('top',`${original.base + height}px`,'important');
        }
      }
      restoreHeaders() {
        for (const [header,original] of this.headerOffsets || []) {
          if (original.top) header.style.setProperty('top',original.top,original.priority);
          else header.style.removeProperty('top');
        }
        if (this.headerOffsets) this.headerOffsets.clear();
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        cancelAnimationFrame(this.frame);
        if (this.observer) this.observer.disconnect();
        if (this.resize) window.removeEventListener('resize',this.resize);
        this.restoreHeaders();
        if (this.originalScrollPadding !== undefined) document.documentElement.style.scrollPaddingTop = this.originalScrollPadding;
        if (this.bar) {this.bar.remove();this.bar=null;}
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
